// *** LOG SERVICE ***

import { i18n } from '@/main';
import { getLocalDate } from '@/services/dateService';

// *** GET ALL LOG FIELD VALUES ***
// Used to get all the editable-field values in the input array in the specified format.
export const getAllLogFieldValues = (fieldArray, includeFullInfo) => {
    if (!fieldArray || !fieldArray.length) {
        return '';
    }

    const fieldValues = fieldArray.reduce((acc, field) => {
        const fieldValue = getLogFieldValue(field, includeFullInfo);
        return acc ? `${acc}; ${fieldValue}` : fieldValue;
    }, '');
    return fieldValues;
};

// *** GET DRUG CARD COMMENT CELL CONTENT ***
// Used to produce the contents of the drug card's "Comments" cell based on
// the provided log's error report description, creator and creation date.
export const getDrugCardCommentCellContent = log => {
    let content = '';
    const displayDescription = log.error_report_description
        ? `${log.error_report_description} [${log.user_name} ${getLocalDate(
              log.created_at,
              i18n.locale,
              false,
              false
          )}]`
        : '';

    if (log.action === 'change') {
        content = i18n.t('inventory_correction');
        content = displayDescription ? `${content} (${displayDescription})` : content;
    } else if (displayDescription) {
        content = displayDescription;
    }

    const displayComments = getAllLogFieldValues(log.comments, true);
    if (displayComments) {
        content = content ? `${content}; ${displayComments}` : displayComments;
    }
    return content;
};

// *** GET LATEST LOG FIELD VALUE ***
// Used to get the formatted value of the latest entry in the input field array.
export const getLatestLogFieldValue = (fieldArray, includeFullInfo, includeQuotes = false) => {
    if (!fieldArray || !fieldArray.length) {
        return '';
    }
    const lastIndex = fieldArray.length - 1;
    return getLogFieldValue(fieldArray[lastIndex], includeFullInfo, includeQuotes);
};

// *** GET LOG FIELD VALUE ***
// Used to format the contents of the input field into the specified format.
// Can be used to include attribution in the value, e.g. "value [user date]".
export const getLogFieldValue = (field, includeFullInfo, includeQuotes = false) => {
    let fieldValue = `${includeQuotes ? '"' : ''}${field.text}${includeQuotes ? '"' : ''}`;
    if (includeFullInfo && field.web_user_name) {
        fieldValue = `${fieldValue} [${field.web_user_name} ${getLocalDate(
            field.created_at,
            i18n.locale,
            false,
            false
        )}]`;
    }
    return fieldValue;
};
